import { datadogLogs } from '@datadog/browser-logs';

export function captureDatadogLogs(logs) {
	datadogLogs.logger.log(logs);
}

export function captureDatadogInfo(message, messageContext, error) {
	datadogLogs.logger.info(message, messageContext, error);
}

export function captureDatadogWarnings(message, messageContext, error) {
	datadogLogs.logger.warn(message, messageContext, error);
}

export function captureDatadogErrors(message, messageContext, error) {
	datadogLogs.logger.error(message, messageContext, error);
}
